export function getWordCount(text) {
   // Find all words by searching for word blobs using the Unicode "letter" character class.
   // See https://unicode.org/reports/tr18/#General_Category_Property
   // and
   // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
   // for more
   const words = [...text.matchAll(/\p{L}+/gu)].length;
   if (words > 1 && words < 25) {
      return words;
   }
   // Perhaps we've got a lanaguage which uses characters, so the
   // non-letter-based word breaking doesn't work well. For that,
   // let's try dividing along script boundaries
   const script_sensitive_boundaries =
      /\p{Script=Katakana}{1,3}|\p{Script=Hiragana}{1,3}|\p{Script=Han}|\p{Script=Latin}+/gu;
   return [...text.matchAll(script_sensitive_boundaries)].length;
}
